import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}

import { useStore } from "vuex";
import { computed, onMounted, ref, Ref } from "vue";


import { defineComponent, defineProps } from 'vue'
import { Notyf } from "notyf";
import { useI18n } from "vue-i18n";


const notyf = new Notyf()

const __default__ = defineComponent({
  name: "ProductTableRow"
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: ['productData'],
  setup(__props) {

const props = __props
const store = useStore()
const { locale } = useI18n();
const editing = ref(false)
const editedPrice = ref('')

const toggleEditing = () => {
  editedPrice.value = props.productData.price
  editing.value = !editing.value
}

const save = async ($t: any) => {


  try {
    await store.dispatch('changePrice', {
      price: editedPrice.value,
      product_id: props.productData.product_id,
    })
    const language = locale.value;
    await store.dispatch('fetchProducts', language)

    toggleEditing()
    notyf.success($t('ProductData.NotyfDataEdited'))
  } catch (e) {
    notyf.error($t('ProductData.NotyfErrorUpdatingData'))
  }

}


onMounted(() => {

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("th", null, _toDisplayString(__props.productData.product_id), 1),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.productData.designation), 1)
    ]),
    _createElementVNode("td", null, [
      (!editing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.productData.price), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedPrice).value = $event)),
            class: "input",
            step: "0.01"
          }, null, 512)), [
            [_vModelText, editedPrice.value]
          ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_2, [
        (!editing.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button is-warning is-small",
              onClick: toggleEditing
            }, _toDisplayString(_ctx.$t('General.Edit')), 1))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "button is-success is-small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (save(_ctx.$t)))
            }, _toDisplayString(_ctx.$t('General.Save')), 1))
      ])
    ])
  ], 64))
}
}

})